// extracted by mini-css-extract-plugin
module.exports = {"layout":"page-header_layout__DGFw0","hero":"page-header_hero__zTEfu","graphic":"page-header_graphic__aOWab","intro":"page-header_intro__8lGQj"};